import { createContext, useContext } from 'react'

/**
 * Context that provides a top offset that can be applied to out-of-flow
 * elements to account for banners.
 */
export const PageTopOffsetContext = createContext(0)

/**
 * Get the top offset that can be applied to out-of-flow elements
 * to account for banners.
 */
export function usePageTopOffset(): number {
  return useContext(PageTopOffsetContext)
}
